import { useEffect, useRef, useState } from "react";

const reduceMotion = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

/** Feine Linienzeichnungen (Verteilung, FI, Typschild …), einmal definiert und per <use> wiederverwendet. */
export function LineArtDefs() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
      <defs>
        <symbol id="ln-board" viewBox="0 0 120 90">
          <rect className="ln-fill" x="18" y="10" width="84" height="70" rx="3" />
          <path className="ln" d="M22 34H98M22 62H98" />
          <rect className="ln-fill" x="26" y="20" width="18" height="24" rx="1.5" />
          <rect className="ln-fill" x="46" y="20" width="8" height="24" rx="1.2" />
          <rect className="ln-fill" x="56" y="20" width="8" height="24" rx="1.2" />
          <rect className="ln-fill" x="66" y="20" width="8" height="24" rx="1.2" />
          <rect className="ln-fill" x="76" y="20" width="8" height="24" rx="1.2" />
          <rect className="ln-fill" x="26" y="48" width="18" height="24" rx="1.5" />
          <rect className="ln-fill" x="46" y="48" width="8" height="24" rx="1.2" />
          <rect className="ln-fill" x="56" y="48" width="8" height="24" rx="1.2" />
          <rect className="ln-fill" x="66" y="48" width="14" height="24" rx="1.2" />
          <rect className="ln-accent" x="48.5" y="26" width="3" height="5" rx=".6" />
          <rect className="ln-accent" x="58.5" y="26" width="3" height="5" rx=".6" />
          <rect className="ln-accent" x="68.5" y="26" width="3" height="5" rx=".6" />
          <rect className="ln-accent" x="78.5" y="26" width="3" height="5" rx=".6" />
        </symbol>
        <symbol id="ln-rcd" viewBox="0 0 120 90">
          <rect className="ln-fill" x="34" y="8" width="52" height="74" rx="3" />
          <path className="ln" d="M34 22H86M34 68H86M44 14v-2M56 14v-2M64 14v-2M76 14v-2M44 76v2M56 76v2M64 76v2M76 76v2" />
          <rect className="ln" x="54" y="32" width="12" height="26" rx="2" />
          <rect className="ln-accent" x="56.5" y="34" width="7" height="10" rx="1" />
          <circle className="ln" cx="76" cy="30" r="4" />
          <path className="ln" d="M74.6 28.6h2.8M76 28.6v3" />
          <path className="ln" d="M40 30h8M40 34h6M40 60h10" />
        </symbol>
        <symbol id="ln-plate" viewBox="0 0 120 90">
          <rect className="ln-fill" x="20" y="18" width="80" height="54" rx="3" />
          <path className="ln" d="M28 30H72M28 38H88M28 46H64M28 54H80M28 62H56" />
          <circle className="ln" cx="88" cy="30" r="5" />
          <rect className="ln-accent" x="28" y="27" width="10" height="3" rx="1" />
        </symbol>
        <symbol id="ln-terminals" viewBox="0 0 120 90">
          <path className="ln" d="M14 50H106" />
          <g>
            {[20, 32, 44, 56, 68, 80].map((x) => (
              <rect key={x} className="ln-fill" x={x} y="30" width="10" height="40" rx="1" />
            ))}
          </g>
          <path
            className="ln"
            d="M25 30C25 18 30 12 40 8M37 30C37 20 44 14 56 10M49 30C49 22 56 16 70 12M61 30V8M73 30C73 20 80 14 92 12M85 30C85 22 92 18 104 16"
          />
          <rect className="ln-accent" x="68" y="44" width="10" height="3" />
        </symbol>
        <symbol id="ln-pe" viewBox="0 0 120 90">
          <rect className="ln-fill" x="16" y="38" width="88" height="14" rx="2" />
          {[28, 44, 60, 76, 92].map((cx) => (
            <circle key={cx} className="ln" cx={cx} cy="45" r="3" />
          ))}
          <path className="ln" d="M28 38C28 26 22 18 12 14M44 38C44 24 40 16 34 10M60 38V10M76 38C76 24 82 16 90 10M92 38C92 26 100 20 110 18" />
          <path className="ln" d="M56 64h8M57.5 68h5M59 72h2M60 52v12" />
          <rect className="ln-accent" x="57" y="40" width="6" height="2" />
        </symbol>
        <symbol id="ln-socket" viewBox="0 0 120 90">
          <rect className="ln-fill" x="30" y="10" width="60" height="70" rx="10" />
          <circle className="ln" cx="60" cy="45" r="20" />
          <circle className="ln" cx="52" cy="45" r="2.6" />
          <circle className="ln" cx="68" cy="45" r="2.6" />
          <path className="ln" d="M57 25.6h6M57 64.4h6" />
          <path className="ln" d="M38 18l4 4" />
          <rect className="ln-accent" x="56" y="24" width="8" height="2" rx="1" />
        </symbol>
      </defs>
    </svg>
  );
}

export function Art({ id }: { id: string }) {
  return (
    <svg viewBox="0 0 120 90" aria-hidden="true">
      <use href={`#ln-${id}`} />
    </svg>
  );
}

const Focus = () => (
  <div className="focus">
    <i />
    <i />
    <i />
    <i />
  </div>
);

const SCENES = ["Auf der Baustelle den Ordner wählen.", "Auslösen. Das Foto liegt sofort im richtigen Ordner.", "Im Büro ist es schon da. Ohne Kabel, ohne Mail."];
const PER_SCENE = 4600;

/** Kurzer Film in drei Szenen: Ordner wählen, Foto schießen, am PC sehen. */
export function DemoPlayer() {
  const [scene, setScene] = useState(0);
  const [playing, setPlaying] = useState(() => !reduceMotion());
  const root = useRef<HTMLDivElement>(null);
  const segs = useRef<(HTMLElement | null)[]>([]);
  const t = useRef(0);

  useEffect(() => {
    let visible = true;
    let last: number | null = null;
    let raf = 0;
    let current = -1;
    const io = "IntersectionObserver" in window ? new IntersectionObserver((es) => (visible = !!es[0]?.isIntersecting)) : null;
    if (root.current) io?.observe(root.current);
    const total = PER_SCENE * SCENES.length;
    const frame = (ts: number) => {
      if (last === null) last = ts;
      if (playing && visible) t.current = (t.current + Math.min(ts - last, 100)) % total;
      last = ts;
      const i = Math.floor(t.current / PER_SCENE);
      if (i !== current) {
        current = i;
        setScene(i);
      }
      segs.current.forEach((s, k) => {
        if (s) s.style.width = `${k < i ? 100 : k > i ? 0 : ((t.current - i * PER_SCENE) / PER_SCENE) * 100}%`;
      });
      raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
    return () => {
      cancelAnimationFrame(raf);
      io?.disconnect();
    };
  }, [playing]);

  const tiles = ["rcd", "plate", "terminals", "pe", "socket", "rcd", "plate"];
  return (
    <div className="player" ref={root}>
      <div className="p-stage">
        <div className={`p-scene${scene === 0 ? " on" : ""}`}>
          <div className="p-phone">
            <div className="p-screen">
              <div className="island" />
              <div className="bar">E-Check 2026</div>
              <div className="sub">Wohnbau Schneider</div>
              {[
                ["00_Unterlagen", 4],
                ["01_Fotos UV2", 12],
                ["02_Prüfbericht", 1],
                ["03_Absprachen", 3],
                ["04_Rechnung", 0],
              ].map(([name, n]) => (
                <div className={`row${name === "01_Fotos UV2" ? " hit" : ""}`} key={name}>
                  <span>{name}</span>
                  <span>{n}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={`p-scene${scene === 1 ? " on" : ""}`}>
          <div className="p-phone">
            <div className="p-screen">
              <div className="p-cam">
                <div className="island" />
                <div className="ph-pill">01_Fotos UV2</div>
                <div className="p-vf">
                  <Art id="board" />
                  <Focus />
                </div>
                <div className="ph-saved">✓ Gespeichert</div>
                <div className="shutter2" />
                <div className="p-flash" />
              </div>
            </div>
          </div>
        </div>
        <div className={`p-scene${scene === 2 ? " on" : ""}`}>
          <div className="p-win">
            <div className="wb">
              <span className="dots">
                <i />
                <i />
                <i />
              </span>
              <span>Wohnbau Schneider / E-Check 2026 / 01_Fotos UV2</span>
            </div>
            <div className="wg">
              <div className="tile fresh">
                <Art id="board" />
              </div>
              {tiles.map((id, k) => (
                <div className="tile" key={k}>
                  <Art id={id} />
                </div>
              ))}
            </div>
          </div>
          <div className="p-toast">
            <i />
            <span>
              <b>Neues Foto von Jan</b> · 01_Fotos UV2
            </span>
          </div>
        </div>
        <div className="p-hud">
          {SCENES.map((_, k) => (
            <span
              className="p-seg"
              key={k}
              onClick={() => {
                t.current = k * PER_SCENE;
                setScene(k);
              }}
            >
              <i ref={(el) => void (segs.current[k] = el)} />
            </span>
          ))}
        </div>
        <div className="p-foot">
          <div>
            <div className="p-step">
              0{scene + 1} / 0{SCENES.length}
            </div>
            <p className="p-cap" aria-live="polite">
              {SCENES[scene]}
            </p>
          </div>
          <button className="p-btn" type="button" aria-label={playing ? "Pause" : "Abspielen"} onClick={() => setPlaying((p) => !p)}>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              {playing ? (
                <g fill="#fff">
                  <rect x="2" y="1" width="2.6" height="10" rx=".6" />
                  <rect x="7.4" y="1" width="2.6" height="10" rx=".6" />
                </g>
              ) : (
                <path d="M3 1.2l7.5 4.8L3 10.8z" fill="#fff" />
              )}
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

/** Satz, der beim Scrollen Wort für Wort aufleuchtet. Wörter mit * davor werden hervorgehoben. */
export function Statement({ text }: { text: string }) {
  const ref = useRef<HTMLParagraphElement>(null);
  const words = text.split(" ");
  const [lit, setLit] = useState(() => (reduceMotion() ? words.length : 0));
  useEffect(() => {
    if (reduceMotion()) return;
    const update = () => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      setLit(Math.round(p * words.length));
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [words.length]);
  return (
    <p className="statement" ref={ref}>
      {words.map((w, i) => {
        const key = w.startsWith("*");
        return (
          <span key={i}>
            <span className={`wd${key ? " key" : ""}${i < lit ? " lit" : ""}`}>{key ? w.slice(1) : w}</span>{" "}
          </span>
        );
      })}
    </p>
  );
}

/** Große Zahl, die hochzählt, sobald sie ins Bild kommt. */
export function CountUp({ value }: { value: number }) {
  const ref = useRef<HTMLElement>(null);
  const [shown, setShown] = useState(value);
  useEffect(() => {
    const el = ref.current;
    if (!el || reduceMotion() || !("IntersectionObserver" in window)) {
      setShown(value);
      return;
    }
    let raf = 0;
    const o = new IntersectionObserver(
      (es) => {
        if (!es[0]?.isIntersecting) return;
        o.disconnect();
        let t0: number | null = null;
        const step = (ts: number) => {
          if (t0 === null) t0 = ts;
          const p = Math.min(1, (ts - t0) / 1400);
          setShown(Math.round(value * (1 - Math.pow(1 - p, 3))));
          if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      },
      { threshold: 0.4 },
    );
    o.observe(el);
    return () => {
      o.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [value]);
  return <b ref={ref}>{shown}</b>;
}

interface Circuit {
  w: number;
  a: string;
  b: string;
}
const ROWS: { y: number; items: Circuit[] }[] = [
  {
    y: 50,
    items: [
      { w: 4, a: "Q1", b: "RCD 40A 30mA" },
      { w: 1, a: "F1", b: "B16" },
      { w: 1, a: "F2", b: "B16" },
      { w: 1, a: "F3", b: "B16" },
      { w: 1, a: "F4", b: "B10" },
      { w: 1, a: "F5", b: "B10" },
    ],
  },
  {
    y: 170,
    items: [
      { w: 4, a: "Q2", b: "RCD 40A 30mA" },
      { w: 1, a: "F6", b: "B16" },
      { w: 1, a: "F7", b: "B16" },
      { w: 1, a: "F8", b: "B20" },
      { w: 3, a: "F9", b: "C16 3P" },
    ],
  },
];

/** Unterverteilung als Linienzeichnung mit schaltbaren Sicherungen und Messwerten daneben. */
export function BoardDemo() {
  const [off, setOff] = useState<string[]>([]);
  const toggle = (a: string) => setOff((o) => (o.includes(a) ? o.filter((x) => x !== a) : [...o, a]));
  const circuits = ROWS.flatMap((r) => r.items.filter((i) => i.w !== 4).map((i) => i.a));
  const offCircuits = off.filter((a) => circuits.includes(a));
  const unit = 34;

  return (
    <div className="elektro">
      <div className="board-wrap">
        <svg className="board" viewBox="0 0 520 320" role="group" aria-label="Unterverteilung UV2, Schutzschalter anklickbar">
          <rect className="encl" x="4" y="4" width="512" height="312" rx="10" />
          <text className="lbl" x="22" y="28">
            UV2 · WOHNBAU SCHNEIDER · EG
          </text>
          <g transform="translate(476 32)">
            <circle className="seal" r="21" />
            <circle className="seal" r="17.5" strokeDasharray="1.5 2" />
            <text className="sealtxt" y="-1" textAnchor="middle">
              GEPRÜFT
            </text>
            <text className="sealtxt" y="8" textAnchor="middle">
              10/26
            </text>
          </g>
          {ROWS.map((row) => {
            let x = 30;
            return (
              <g key={row.y}>
                <path className="rail" d={`M20 ${row.y + 50}H500M20 ${row.y + 58}H500`} />
                {row.items.map((it) => {
                  const w = it.w * unit - 3;
                  const rcd = it.w === 4;
                  const cx = x + w / 2;
                  const x0 = x;
                  x += it.w * unit;
                  const isOff = off.includes(it.a);
                  return (
                    <g
                      key={it.a}
                      className={`brk${isOff ? " off" : ""}`}
                      tabIndex={0}
                      role="button"
                      aria-pressed={!isOff}
                      aria-label={`${it.a} ${it.b}`}
                      onClick={() => toggle(it.a)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggle(it.a);
                        }
                      }}
                    >
                      <rect className="mod" x={x0} y={row.y + 8} width={w} height={92} rx={3} />
                      <path className="rail" d={`M${x0 + 3} ${row.y + 22}H${x0 + w - 3}M${x0 + 3} ${row.y + 86}H${x0 + w - 3}`} />
                      <rect className="slot" x={cx - 6} y={row.y + 38} width={12} height={30} rx={2.5} />
                      <rect className="lever" x={cx - 4} y={row.y + 40} width={8} height={13} rx={1.6} />
                      <rect className="win-ind" x={x0 + 5} y={row.y + 28} width={rcd ? 10 : w - 10} height={3} rx={1} />
                      {rcd && (
                        <>
                          <circle className="test" cx={x0 + w - 14} cy={row.y + 32} r={5} />
                          <text className="lbl2" x={x0 + w - 16.5} y={row.y + 35}>
                            T
                          </text>
                        </>
                      )}
                      <text className="lbl" x={x0 + 5} y={row.y + 19}>
                        {it.a}
                      </text>
                      <text className="lbl2" x={x0 + 5} y={row.y + 96}>
                        {it.b}
                      </text>
                    </g>
                  );
                })}
              </g>
            );
          })}
          <path className="bus" d="M22 292H498" />
          <text className="lbl2" x="22" y="306">
            N / PE
          </text>
        </svg>
      </div>
      <div className="stack">
        <h3 className="ph3">Prüfprotokolle mit Fotos und Messwerten</h3>
        <p className="lead">Jeder Stromkreis, jedes Foto und jeder Messwert gehört zum Projekt. Das Protokoll entsteht daraus, nicht daneben.</p>
        <dl className="meas">
          <div>
            <dt>
              Isolationswiderstand<small>R_ISO · F3</small>
            </dt>
            <dd>
              &gt; 500 MΩ<small>in Ordnung</small>
            </dd>
          </div>
          <div>
            <dt>
              Schleifenimpedanz<small>Z_S · F3</small>
            </dt>
            <dd>
              0,42 Ω<small>in Ordnung</small>
            </dd>
          </div>
          <div>
            <dt>
              Fehlerstromschutz<small>Q1 · I_ΔN 30 mA</small>
            </dt>
            <dd>
              18 ms<small>in Ordnung</small>
            </dd>
          </div>
          <div className={offCircuits.length ? "warn" : undefined}>
            <dt>
              Stromkreise<small>UV2</small>
            </dt>
            <dd>
              {circuits.length - offCircuits.length} / {circuits.length}
              <small>{offCircuits.length ? `${offCircuits.join(", ")} ausgeschaltet` : "alle eingeschaltet"}</small>
            </dd>
          </div>
        </dl>
        <p style={{ fontSize: ".8rem", color: "var(--muted)" }}>Beispielwerte. Tippen Sie auf einen Schutzschalter in der Verteilung.</p>
      </div>
    </div>
  );
}

/** Unterweisungsnachweis; die Unterschrift zeichnet sich, sobald das Blatt sichtbar wird. */
export function ProofPaper() {
  const ref = useRef<HTMLDivElement>(null);
  const [drawing, setDrawing] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || reduceMotion() || !("IntersectionObserver" in window)) return;
    const o = new IntersectionObserver(
      (es) => {
        if (es[0]?.isIntersecting) {
          setDrawing(false);
          requestAnimationFrame(() => setDrawing(true));
        }
      },
      { threshold: 0.5 },
    );
    o.observe(el);
    return () => o.disconnect();
  }, []);
  return (
    <div className={`paper${drawing ? " drawing" : ""}`} ref={ref} aria-label="Beispiel eines Unterweisungsnachweises">
      <span className="paper-k">Unterweisungsnachweis</span>
      <h3>Leitern und Tritte</h3>
      <dl className="kv">
        <dt>Mitarbeiter</dt>
        <dd>Lena Vogt</dd>
        <dt>Unterwiesen von</dt>
        <dd>Jan Müller</dd>
        <dt>Datum</dt>
        <dd>17.10.2026</dd>
        <dt>Dauer</dt>
        <dd>45 Minuten</dd>
      </dl>
      <div className="sign">
        <svg viewBox="0 0 240 70" aria-hidden="true">
          <path
            className="sig"
            d="M10 48c12-26 22-30 26-18s-6 24 2 20 14-30 22-28-4 26 4 24 10-16 16-14 0 12 8 10 12-20 20-18-2 16 6 15 18-10 26-12 14 6 22 2 20-8 30-6"
          />
        </svg>
        <span>Unterschrift Lena Vogt, auf dem Handy geleistet</span>
      </div>
    </div>
  );
}
